<!-- からだ手帳-->
<template>
  <!-- storeのstatusがfetchになるまで表示 -->
  <Progress v-if="getStampData === 'loading'" title="Loading..." />

  <karada-diary v-else>
    <header-title :title="$t('menu.karadaNote')" slot="header" />
    <calendar slot="calendar" @set="setCurrentDate" />

    <!--Fix karadaNote--containerのwidthが指定されていない -->
    <div class="karada-note--container" slot="karada-note-container">
      <heading :title="$t('notebook.EnterInfo')" />

      <div class="karada-note--content">
        <div class="karada-note--content__date">
          {{ currentDate | MonthDateJa }}
        </div>
        <!-- form -->
        <!--Fix formの幅が異常 -->
        <div class="karada-note--content__form">
          <!-- 体重 -->
          <label for="weight">{{ $t("notebook.bodyWeight") }}</label>
          <input
            type="number"
            class="karada-note--content__form--content karada-note--content__form--content__weight"
            name="weight"
            v-model.number="form.weight"
            min="0.0"
            max="200.0"
            :data-test="currentDate | MonthDateJa"
          />
          <!-- 血圧 -->
          <label for="bp">{{ $t("notebook.bloodPressure") }}</label>
          <input
            type="number"
            class="karada-note--content__form--content karada-note--content__form--content__bp-high"
            name="bp-high"
            :placeholder="$t('notebook.top')"
            v-model.number="form.bloodHigh"
            min="0.0"
            max="400.0"
          />
          <input
            type="number"
            class="karada-note--content__form--content karada-note--content__form--content__bp-low"
            name="bp-low"
            :placeholder="$t('notebook.bottom')"
            v-model.number="form.bloodLow"
            min="0.0"
            max="250.0"
          />
          <!-- 体脂肪率 -->
          <label for="fat">体脂肪率</label>
          <input
            type="number"
            class="karada-note--content__form--content karada-note--content__form--content__weight"
            name="fat"
            min="0.0"
            max="200.0"
            v-model.number="form.fat"
            :data-test="currentDate | MonthDateJa"
          />
        </div>
        <!-- stamp -->
        <karada-stamps
          class="karada-note--content__stamp"
          slot="stamps"
          :stampData="form"
          @setStampData="setStampData"
        />

        <!-- button -->
        <button-component
          :buttonLabel="$t('common.save')"
          methods="setHealthData"
          @setHealthData="setHealthData"
          slot="save-button"
          class="karada-note--content__button"
        />
      </div>
    </div>

    <div class="chart-wrapper" slot="weight-chart">
      <div class="chart-title">{{ $t("notebook.bodyWeight") }}</div>
      <chart-weight slot="weight-chart" :label="getLabel" :weight="getWeight" />
    </div>

    <div class="chart-wrapper" slot="bmi-chart">
      <div class="chart-title">BMI</div>
      <chart-bmi
        slot="Bmi-chart"
        :label="getLabel"
        :weight="getWeight"
        :height="getHeight"
      />
    </div>

    <div class="chart-wrapper" slot="bp-chart">
      <div class="chart-title">{{ $t("notebook.bloodPressure") }}</div>
      <chart-blood-presure
        :label="getLabel"
        :bloodHigh="getBloodPresureHigh"
        :bloodLow="getBloodPresureLow"
      />
    </div>

    <div class="chart-wrapper" slot="ebf-chart">
      <div class="chart-title">体脂肪率</div>
      <chart-fat
        :label="getLabel"
        :fat="getFat"
      />
    </div>

    <div class="chart-wrapper" slot="ebf-chart">
      <div class="chart-title">徐脂肪体重</div>
      <chartExcludedBodyFatPercentage
        :label="getLabel"
        :weight="getWeight"
        :fat="getFat"
      />
    </div>
  </karada-diary>
</template>

<script>
import dateFns from "date-fns";

// organisms
import KaradaDiary from "../components/organisms/KaradaDiary/KaradaDiary";

//molecules
import KaradaStamps from "../components/molecules/KaradaDiary/KaradaStamps";
import InputNum from "../components/molecules/AiDiseasePrediction/InputNum";

// atoms
import HeaderTitle from "../design/HeaderTitleSlot";
import Heading from "../components/atoms/AIDiseasePredictionReport/Heading";
import ButtonComponent from "../components/atoms/Button";
import Progress from "../components/atoms/Progress";

// chart
import chartWeight from "../plugin/chart/LineChartWeight";
import chartBmi from "../plugin/chart/LineChartBmi";
import chartBloodPresure from "../plugin/chart/LineChartBloodPresure";
import chartExcludedBodyFatPercentage from "../plugin/chart/LineChartExcludedBodyFatPercentage";
import chartFat from "../plugin/chart/LineChartFat.vue"

import Calendar from "../components/molecules/KaradaDiary/Calendar";

export default {
  data() {
    return {
      currentDate: null,
      healthData: {},
      form: {}
    };
  },
  components: {
    // organisms
    KaradaDiary,
    // molecules
    KaradaStamps,
    InputNum,
    //atoms
    HeaderTitle,
    Heading,
    ButtonComponent,
    Progress,
    // chart
    chartWeight,
    chartBmi,
    chartBloodPresure,
    chartExcludedBodyFatPercentage,
    chartFat,

    Calendar
  },
  computed: {
    getHealthData: function() {
      const res = this.$store.state.health.status;
      if (res) {
        return this.$store.getters["health/getHealthData"];
      }
    },
    // 日付を配列で取得
    getLabel() {
      return Object.keys(this.getHealthData);
    },
    getHeight() {
      return this.$store.state.users.height;
    },
    // 体重
    getWeight() {
      return this.getLabel.map(v => this.getHealthData[v].weight);
    },
    // 最高血圧
    getBloodPresureHigh() {
      return this.getLabel.map(v => this.getHealthData[v].bloodHigh);
    },
    getBloodPresureLow() {
      return this.getLabel.map(v => this.getHealthData[v].bloodLow);
    },
    getFat() {
      return this.getLabel.map(v => this.getHealthData[v].fat);
    },
    getStampData() {
      if (this.$store.state.health.status === "fetch") {
        const data = this.getHealthData[this.getFormatedDate];
        let clonedData = {};
        if (data) {
          clonedData = JSON.parse(JSON.stringify(data));
          this.form = clonedData;
        } else {
          this.form = {
            weight: null,
            bloodHigh: null,
            bloodLow: null,
            bowel: false,
            alcohol: false,
            exercise: false,
            conditionGood: false,
            conditionBad: false,
            medicine: false
          };
        }
      } else {
        return "loading";
      }
    },
    // YYYYMMDD形式に加工する
    getFormatedDate() {
      return dateFns.format(this.currentDate, "YYYYMMDD");
    }
  },
  created() {
    // Firebaseから、カラダ手帳のデータを全て取得
    this.fetchHealthData(this.$store.state.auth.user.uid);
    // Firebaseから、診断結果のデータを全て取得
    this.fetchKarteData(this.$store.state.auth.user.uid);
    // 日付を代入
    const day = new Date();
    this.setCurrentDate(day);
  },
  methods: {
    setCurrentDate(day) {
      this.currentDate = day;
    },
    // からだ手帳データの新規登録・更新
    setHealthData() {
      this.$store.dispatch("health/sendHealthToFirebase", {
        uid: this.$store.state.auth.user.uid,
        date: this.getFormatedDate,
        healthData: this.form
      });
      alert(this.$t("common.saved"));
      //要検討!! 変更後のfirebaseをstateに反映させる(コスト的に如何なものか)
      this.fetchHealthData(this.$store.state.auth.user.uid);
    },
    // からだ手帳データの削除
    deleteHealthData() {
      this.$store.dispatch("health/deleteHealthToFirebase", {
        uid: this.$store.state.auth.user.uid,
        date: this.getFormatedDate
      });
    },
    // からだ手帳データの取得
    async fetchHealthData() {
      await this.$store.dispatch(
        "health/fetchHealthFromFirebase",
        this.$store.state.auth.user.uid
      );
    },
    // スタンプのbool値を切り替える
    setStampData(index) {
      this.$set(this.form, index, !this.form[index]);
    },
    // カルテデータの取得
    fetchKarteData() {
      this.$store.dispatch(
        "karte/fetchKarteFromFirebase",
        this.$store.state.auth.user.uid
      );
    }
  },
  filters: {
    MonthDateJa(val) {
      return dateFns.getMonth(val) + 1 + "月" + dateFns.getDate(val) + "日";
    }
  }
};
</script>

<style scoped>
/* 入力フォーム */
.karada-diary {
  width: 65vw;
}
</style>
